var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "preview-dialog",
    attrs: {
      "title": "预览",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.baseData) ? _c('el-form', {
    staticClass: "preview-inlineForm",
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模板名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.name) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮件标题",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.baseData.title))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "招聘阶段",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_PHASE', _vm.baseData.phase)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户类型",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getSelectMapText('WB_USER_ATTRIBUTES', _vm.baseData.userAttributes)) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否可用",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.visible ? '可用' : '不可用') + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否私有",
      "label-width": _vm.formLabelWidth
    }
  }, [_vm._v("\n            " + _vm._s(_vm.baseData.isPrivate ? '是' : '否') + "\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.baseData) ? _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "邮件内容",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.baseData.content)
    }
  })])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c887b67"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/message/viewEmailTpl.vue
// module id = null
// module chunks = 